import { useProductStore } from '../../../../store/useProduct';
import { formatNumberWithComma, getDiscountRate } from '../../../../util/util';

/**
 * @author taulmax
 * @createDate 2024.10.30
 * @description 상품 상세 페이지 - 금액
 */
const PDPrice = () => {
  const { productDetail } = useProductStore();

  if (!productDetail) {
    return (
      <div className="animate-pulse">
        <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
        <div className="h-8 w-32 bg-gray-200 rounded"></div>
      </div>
    );
  }

  const isDiscount = productDetail.discountPrice;

  return (
    <div>
      {!!isDiscount ? (
        <div>
          <div className="flex items-center gap-3 mb-1">
            <span className="text-sm text-gray-500 line-through">
              {formatNumberWithComma(productDetail.price)}원
            </span>
            <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-0.5 rounded">
              {getDiscountRate(productDetail.discountPrice, productDetail.price)}% 할인
            </span>
          </div>
          <div className="text-xl font-bold text-gray-900">
            {formatNumberWithComma(productDetail.discountPrice)}원
          </div>
        </div>
      ) : (
        <div className="text-xl font-bold text-gray-900">
          {formatNumberWithComma(productDetail.price)}원
        </div>
      )}
    </div>
  );
};

export default PDPrice;
